import { getInstallInfo } from './getInstallInfo'

export async function getHostBrowserAppVersion(): Promise<string> {
  const installInfo = await getInstallInfo()
  return installInfo?.version || 'unknown'
}
